export const PLAN = {
  pro: 'pro',
  basic: 'basic',
  free: 'free',
};
